<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let llave;

    let requisitos = [
        { clave: "1", desc: "Entre 6 y 20 caracteres", estado: "NO" },
        { clave: "2", desc: "Letras mayúsculas ", estado: "NO" },
        { clave: "2", desc: "Letras minúsculas", estado: "NO" },
        { clave: "3", desc: "Números.", estado: "NO" },
        { clave: "4", desc: "Alguno de estos caracteres: $ @ *", estado: "NO" },
        { clave: "5", desc: "Contraseñas iguales", estado: "NO" },
    ];

    let letras =
        "abcdefghijklmnñopqrstuvwxyzáéíóúüABCDEFGHIJKLMNÑOPQRSTUVWXYZÁÉÍÓÚÜ0123456789@$*";

    let tblmensaje = "";

    let backgroundColor = "white";

    let displayMensaje = "none";

    let p1 = "";
    let p2 = "";

    let displayModalAviso = "none";
    let aviso = "";

    function cargar() {
        try {
            let tbl = document.getElementById("tbodyEstado");
            let filas = "";
            requisitos.map(function (r) {
                filas +=
                    "<tr><td>" +
                    r.desc +
                    "</td><td style='text-align:center'>" +
                    r.estado +
                    "</td></tr>";
            });
            tbl.innerHTML = filas;
        } catch (e) {}
    }

    function recargar() {
        for (let i = 0; i < requisitos.length; i++) {
            requisitos[i]["estado"] = "NO";
        }

        let si = "<span style='color:blue'>SI</span>";

        let contrasenna = document.getElementById("pwd1").value;

        if (contrasenna.length >= 6 && contrasenna.length <= 20)
            requisitos[0]["estado"] = si;

        for (var i = 0; i < contrasenna.length; i++) {
            if (
                contrasenna.charCodeAt(i) >= 65 &&
                contrasenna.charCodeAt(i) <= 90
            ) {
                requisitos[1]["estado"] = si;
            } else if (
                contrasenna.charCodeAt(i) >= 97 &&
                contrasenna.charCodeAt(i) <= 122
            ) {
                requisitos[2]["estado"] = si; //minuscula = true;
            } else if (
                contrasenna.charCodeAt(i) >= 48 &&
                contrasenna.charCodeAt(i) <= 57
            ) {
                requisitos[3]["estado"] = si; //numero = true;
            } else if (
                contrasenna.charCodeAt(i) == 42 ||
                contrasenna.charCodeAt(i) == 64 ||
                contrasenna.charCodeAt(i) == 36
            ) {
                requisitos[4]["estado"] = si; //caracter_raro = true;
            }
        }

        let p1 = document.getElementById("pwd1").value;
        let p2 = document.getElementById("pwd2").value;
        if (p1 === p2 && p1.length > 3) requisitos[5]["estado"] = si;

        //cargar();
    }

    function tblmensajeset() {
        tblmensaje = "";
        displayMensaje = "none";
        backgroundColor = "white";
    }

    function continuar() {
        /* 
        let nov = "";

        for (let i = 0; i < p1.length; i++) {
            let non = 0;
            for (let j = 0; j < letras.length; j++) {
                if (p1.substr(i, 1) == letras.substr(j, 1)) non++;
            }
            if (non == 0) nov += p1.substr(i, 1);
        }

        if (p1.trim() != p2.trim() || p1.trim().length < 4) non++;

        if (nov.length > 0) {
            let xx = "Ingresó caracteres no válidos: ";
            xx += "<span style='background-color:red'>" + nov + "</span>";
            // document.getElementById("tblmensaje").style.backgroundColor =
            //     "yellow";
            // document.getElementById("tblmensaje").innerHTML = xx;

            backgroundColor = "yellow";
            tblmensaje = xx;
            displayMensaje = "block";
            return;
        }

        if (p1.trim().length == 0) {
            backgroundColor = "yellow";
            tblmensaje = "No cumple con los requisitos";
            displayMensaje = "block";
            return;
        }
 */
        let nocumple = 0;

        requisitos.map((r) => {
            if (r.estado.includes("NO")) nocumple++;
        });

        if (nocumple > 0) {
            backgroundColor = "yellow";
            tblmensaje = "No cumple con los requisitos";
            displayMensaje = "block";
            return;
        }
        actualizar();
    }

    function actualizar() {
        let param = new FormData();
        param.append("accion", "cambiarContrasenia");
        param.append("pwd", p1);
        param.append("token", llave);
        //alert('llave:'+llave);
        //fetch("usuarios.php",{
        fetch("api/usuarios.php", {
            method: "POST",
            body: param,
        })
            .then((response) => response.json())
            .then((data) => {
                aviso = data.mensaje;
                displayModalAviso = "block";
            });
    }

    function finalizar() {
        displayModalAviso='none';
        dispatch('volver');
    }
</script>

<div class="w3-content" style="max-width:500px; margin-top:30px">
    <div class="w3-padding w3-border w3-round">
        <h3>Crear o modificar tu contraseña</h3>
        <div
            on:click={() => {
                displayMensaje = "none";
                tblmensaje = "";
                backgroundColor = "white";
            }}
        >
            <div class=" w3-section">
                <label>Contraseña nueva:</label>
                <input
                    type="password"
                    name="pwd1"
                    id="pwd1"
                    on:keyup={recargar}
                    class="w3-input w3-light-grey"
                    bind:value={p1}
                />
            </div>
            <div class=" w3-section">
                <label>Repetir contraseña:</label>
                <input
                    type="password"
                    name="pwd2"
                    id="pwd2"
                    on:keyup={recargar}
                    class="w3-input w3-light-grey"
                    bind:value={p2}
                />
            </div>
        </div>
        <div class=" w3-section w3-tiny">
            <table class="w3-table-all">
                <thead>
                    <tr>
                        <th>Requisitos</th>
                        <th>Cumplido</th>
                    </tr>
                </thead>
                <tbody id="tbodyEstado">
                    {#each requisitos as r}
                        <tr>
                            <td>{r.desc}</td>
                            <td>{@html r.estado}</td>
                        </tr>
                    {/each}
                </tbody>
                <tfoot>
                    <tr
                        ><td
                            id="tblmensaje"
                            colspan="2"
                            style="text-align:center; background-color:{backgroundColor}; "
                            ><div style="display:{displayMensaje}">
                                {@html tblmensaje}
                            </div></td
                        ></tr
                    >
                </tfoot>
            </table>
        </div>

        <div class=" w3-section">
            <input
                type="button"
                class="w3-btn w3-blue w3-round"
                on:click|preventDefault={continuar}
                value="Continuar"
            />
            <input
                type="button"
                class="w3-btn w3-red w3-round w3-right"
                on:click|preventDefault={() => dispatch("volver")}
                value="Canccelar"
            />
        </div>
    </div>
</div>

<div id="modalAviso" class="w3-modal" style="display:{displayModalAviso}">
    <div class="w3-modal-content w3-card-4">
        <header class="w3-container w3-blue">
            <h3>Crear o modificar tu contraseña</h3>
        </header>
        <div class="w3-container">
            <div class="w3-section">
                <p id="aviso" class="w3-medium">{aviso}</p>
            </div>
            <div class="w3-section">
                <button
                    class="w3-btn w3-medium w3-blue w3-round"
                    on:click={finalizar}>Continuar</button
                >
            </div>
        </div>
    </div>
</div>
